exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".gdpr-checkbox .shape{border-color:#ddd}.gdpr-checkbox .check{height:10px;width:16px;border-color:#424242}.gdpr-textarea{background-color:#fff;border:1px solid #ddd;padding:8px 12px;color:#464646}.mc-checkbox .checkbox-wrap{max-width:17px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/css-loader?minimize!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/autoprefixer-loader?{browsers:["last 3 versions"],cascade:false}!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/stylus-loader??ref--6-3!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/GDPR-popups/stylus/gdpr.styl
// module id = 109
// module chunks = 5